/* Majica Studio: native Shopify forms handle cart, availability and checkout. */
(() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('[data-menu-toggle]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      button.addEventListener('click', () => {
        const open = menu.hidden;
        menu.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? window.MajcotekaI18n.menu_close : window.MajcotekaI18n.menu_open);
      });
      menu.addEventListener('click', event => {
        if (event.target.closest('a')) {
          menu.hidden = true;
          button.setAttribute('aria-expanded', 'false');
        }
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          menu.hidden = true;
          button.setAttribute('aria-expanded', 'false');
          button.focus();
        }
      });
    });
    scope.querySelectorAll('.product-form').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const select = form.querySelector('[data-variant-select]');
      const button = form.querySelector('[data-add-button]');
      const prices = form.querySelectorAll('[data-form-price]');
      const quantity = form.querySelector('[data-quantity-input]');
      const label = form.querySelector('[data-add-label]');
      const defaultLabel = window.MajcotekaI18n?.add || 'Dodaj u košaricu';
      function updateVariant() {
        const option = select?.selectedOptions[0];
        if (!option) return;
        prices.forEach(price=>price.textContent=option.dataset.price||'-');
        const available = option.dataset.available === 'true';
        const accelerated=form.querySelector('[data-accelerated]');if(accelerated)accelerated.hidden=!available;
        if (button) button.disabled = !available || button.hasAttribute('data-subscription-required');
        if (label) label.textContent = available ? defaultLabel : (window.MajcotekaI18n?.sold || 'Rasprodano');
        if (quantity) {
          const min = Number(option.dataset.min) || 1;
          const step = Number(option.dataset.step) || 1;
          quantity.min = String(min);
          quantity.step = String(step);
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = String(min);
        }
        if (document.body.classList.contains('template-product')) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState(null, '', url);
        }
      }
      select?.addEventListener('change', updateVariant);
      form.addEventListener('submit', event => {
        const text = form.querySelector('[data-custom-text], [data-personalization-text]');
        if (text && !text.value.trim()) {
          event.preventDefault();
          text.setCustomValidity('Upiši svoj natpis.');
          text.reportValidity();
          return;
        }
        if (select?.selectedOptions[0]?.dataset.available !== 'true') {
          event.preventDefault();
          return;
        }
        if (button?.hasAttribute('data-subscription-required')) event.preventDefault();
      });
      form.querySelectorAll('[data-personalization-text]').forEach(text => text.addEventListener('input', () => text.setCustomValidity('')));
    });
    scope.querySelectorAll('[data-customizer]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const input = section.querySelector('[data-custom-text]');
      const preview = section.querySelector('[data-print-preview]');
      const count = section.querySelector('[data-char-count]');
      if (!input || !preview) return;
      const update = () => {
        input.setCustomValidity('');
        const value = input.value.trim() || 'TVOJ NATPIS';
        preview.firstElementChild.textContent = value === 'BAŠ PO MOM.' ? 'BAŠ\nPO MOM.' : value;
        preview.style.fontSize = value.length > 22 ? '23px' : value.length > 15 ? '28px' : '';
        if (count) count.textContent = input.value.length + '/32';
      };
      input.addEventListener('input', update);
      section.querySelectorAll('[data-ink]').forEach(radio => radio.addEventListener('change', () => {
        if (radio.checked) preview.style.color = radio.dataset.ink;
      }));
      update();
    });
    scope.querySelectorAll('[data-sort-select]').forEach(select => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    scope.querySelectorAll('[data-cart-quantity]').forEach(input => {
      if (input.dataset.initialized) return;
      input.dataset.initialized = 'true';
      input.addEventListener('input', () => {
        const note = input.form.querySelector('[data-cart-dirty]');
        if (note) note.hidden = false;
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
